export default {
    namespaced: true,
    state: {
        users: [],
        roles: []
    },
    mutations: {
        SET_USERS(state, users) {
            state.users.push(...users.map(user => {
                return {
                    user: user,
                    username: user.getUsername(),
                    email:user.getEmail(),
                    password:''
                }
            }));
        },
        SET_ROLES(state, roles){
            state.roles.push(...roles.map(role=>{
                return {
                    role: role,
                    roleName: role.getName()
                }
            }))
        }
    },
    getters: {
        getUsers: (state) => {
            return state.users;
        },
        getRoles: (state)=>{
            return state.roles;
        }
    }
}